import React from 'react'

const Data_Policy = () => {
  return (
    <div className="bg-white">
      <div className="mt-5 ml-5 w-[95%] md:w-[90%] md:mx-auto md:px-20 px-4">
        <h1 className="md:text-[24px] text-[10px] font-semibold mt-5 md:pt-10 pt-5">
          PRIVACY POLICY
        </h1>
        <p className="inline md:text-[17px] text-[10px] font-bold text-[#979797] break-words whitespace-normal italic">
          Last updated on 22nd March 2025
        </p>

        <div className="md:h-6 h-1" />

        <div className="mt-10 md:text-[32px] text-[10px] text-black leading-relaxed font-normal md:space-y-0 space-y-4">
          <p>
            Farmers Networks / Farmnet ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy describes how we collect, use, and protect your personal information when you access or use our website, mobile app, and services (collectively referred to as the "Platform"). By using our Platform, you agree to the terms outlined in this Privacy Policy.
          </p>
          <div className="md:h-3 h-1" />

          <p className="font-bold md:mt-10">1. Information We Collect</p>
          <p>We collect the following types of information:</p>

          <p className="font-bold">a) Personal Information</p>
          <ul className="list-disc ml-6 md:ml-8">
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Farm location/address</li>
            <li>Government-issued ID (if required for verification)</li>
          </ul>

          <p className="font-bold">b) Agricultural and Business Information</p>
          <ul className="list-disc ml-6 md:ml-8">
            <li>Farm size and type</li>
            <li>Crops or livestock details</li>
            <li>Production or market data</li>
            <li>Trading or transaction history on the platform</li>
          </ul>

          <p className="font-bold">c) Technical Information</p>
          <ul className="list-disc ml-6 md:ml-8">
            <li>Device type and browser</li>
            <li>IP address</li>
            <li>Access logs and interaction data</li>
            <li>Cookies and other tracking technologies</li>
          </ul>

          <p className="font-bold">d) Optional Data</p>
          <ul className="list-disc ml-6 md:ml-8">
            <li>Photos, comments, or content you upload</li>
            <li>Feedback or survey responses</li>
          </ul>

          <div className="md:h-12 h-1" />

          <p className="font-bold">2. How We Use Your Information</p>
          <ul className="list-disc ml-6 md:ml-8">
            <li>Create and manage your user account</li>
            <li>Facilitate networking with other farmers and agri-businesses</li>
            <li>Share relevant agricultural content and updates</li>
            <li>Provide support and respond to your inquiries</li>
            <li>Improve platform performance and develop new features</li>
            <li>Monitor and prevent fraud or misuse</li>
          </ul>

          <div className="md:h-8 h-1" />

          <p className="font-bold">3. How We Share Your Information</p>
          <ul className="list-disc ml-6 md:ml-8">
            <li>Other registered users (with your consent or via your profile settings)</li>
            <li>Service providers who help us run our operations (e.g., IT support, hosting)</li>
            <li>Agricultural institutions or partners, for educational or business support (anonymized where appropriate)</li>
            <li>Government or legal authorities when required by law</li>
            <li>Buyers or suppliers if you engage in marketplace transactions</li>
          </ul>
          <p>We do not sell your personal data to third parties.</p>

          <div className="md:h-12 h-1" />


          <p className="font-bold">4. Your Privacy Rights</p>
          <p>Depending on your location and local regulations (such as GDPR or other privacy laws), you may have rights including:</p>
          <ul className="list-disc ml-6 md:ml-8">
            <li>Access to your personal data</li>
            <li>Correction or deletion of your data</li>
            <li>Restriction or objection to data processing</li>
            <li>Withdrawal of consent</li>
            <li>Data portability</li>
          </ul>
          <p>To exercise your rights, email us at <a href="mailto:support@farmnet.africa">support@farmnet.africa</a>.</p>

          <div className="md:h-12 h-1" />


          <p className="font-bold">5. Cookies and Tracking Technologies</p>
          <p>
            We use cookies to:
          </p>
          <ul className="list-disc ml-6 md:ml-8">
            <li>Recognize you on future visits</li>
            <li>Analyze platform usage</li>
            <li>Deliver personalized content or recommendations</li>
          </ul>
          <p>You can adjust your cookie settings in your browser at any time.</p>

          <div className="md:h-12 h-1" />


          <p className="font-bold">6. Data Retention</p>
          <p>
            We keep your data only for as long as needed to provide our services and meet legal or regulatory requirements. You may request deletion of your data at any time, subject to applicable laws.
          </p>

          <div className="md:h-12 h-1" />


          <p className="font-bold">7. Data Security</p>
          <p>
            We take data protection seriously and use industry-standard security practices to safeguard your information, including encryption, firewalls, and access controls.
          </p>

          <div className="md:h-12 h-1" />


          <p className="font-bold">8. Children’s Privacy</p>
          <p>
            Our services are not intended for children under the age of 13 (or the minimum legal age in your country). We do not knowingly collect data from children.
          </p>

          <div className="md:h-12 h-1" />


          <p className="font-bold">9. International Users</p>
          <p>
            If you use the platform from outside Kenya, your data may be transferred to and processed in South Africa, where privacy laws may differ.
          </p>

          <div className="md:h-12 h-1" />


          <p className="font-bold">10. Changes to This Privacy Policy</p>
          <p>
            We may update this Privacy Policy occasionally. If we make material changes, we will notify you by email or post a notice on the Platform.
          </p>

          <div className="md:h-12 h-1" />


          <p className="font-bold">11. Contact Us</p>
          <p>
            If you have any questions or concerns about this Privacy Policy or how your data is handled, please contact us at:
          </p>
          <p>Email: <a href="mailto:support@farmnet.africa">support@farmnet.africa</a></p>
        </div>
        <div className="md:h-10 h-5" />
      </div>
    </div>
  )
}

export default Data_Policy
